import React from 'react';
import Poi from 'models/Poi';
import Tooltip from 'components/TippyTooltip';
import PoiTypeIcon from 'components/icons/PoiTypeIcon';
import { formatDistance } from 'utils/formatting';
import SmallCard from 'components/cards/SmallCard';

const PoiCardHorizontal = ({ poi, label, featured = false }: { featured?: boolean; poi: Poi; label?: string }) => {
    let featuredImage = { url: '/images/poi-card-fallback-image.jpg' };
    if (poi.thumbs && poi.thumbs.length > 0) {
        featuredImage = poi.thumbs[0];
    }
    return (
        <SmallCard
            key={poi.id}
            featured={featured}
            image={featuredImage}
            alt={poi.name}
            link={`/ideja/${poi.slug}`}
            prefetch={false}>
            <div className="pt-2 pb-1 pl-2 relative">
                <div className="absolute -left-12 -top-1 w-12 h-12 rounded-full shadow-md bg-white flex items-center justify-center ">
                    <Tooltip
                        title={poi.type.name}
                        position="top"
                        arrow={true}
                        size="small"
                        arrowSize="small"
                        distance={5}
                        animation="fade">
                        <div>
                            <PoiTypeIcon slug={poi.type.slug} size={28} />
                        </div>
                    </Tooltip>
                </div>

                <div>
                    <h4 className="leading-tight font-medium text-brand font-serif">{poi.name}</h4>
                    {label && <div className=" text-sm text-gray-600 font-semibold ">{label}</div>}
                </div>
                {poi.distance && (
                    <div className="mt-4 flex items-center">
                        <div className="font-light leading-tight text-sm w-1/2">Oddaljenost</div>
                        <div className="font-medium w-1/2">{formatDistance(poi.distance)}</div>
                    </div>
                )}
            </div>
        </SmallCard>
    );
};

export default PoiCardHorizontal;
